module.exports = __webpack_public_path__ + "static/media/about.30b37ca3.svg";